import { memo } from "react";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import "./BaggageFreeTag.scss";
import IconCheckInLuggageAvailable from "app/pages/.shared/static/icons/IconCheckInLuggageAvailable";

const BaggageFreeTag = () => {
	return (
		<div className="baggage-free-tag" data-testid="baggage-free-tag">
			<IconCheckInLuggageAvailable data-testid="icon-check-luggage" />
			<Typography
				variant={TYPOGRAPHY_VARIANTS.SMALL}
				isBold
				className="baggage-free-tag__label"
			>
				<FormattedMessage id="product.baggage.free.tag" />
			</Typography>
		</div>
	);
};

export default memo(BaggageFreeTag);
